import React from "react";

function ConfigDetailsModal({ isOpen, onClose, data }) {
  if (!isOpen || !data) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Detalhes da Configuração</h3>
        <div style={{ marginBottom: 16 }}>
          <strong>ID:</strong> {data.id}<br />
          <strong>Turma:</strong> {data.course?.name || data.attendance_session?.course?.name || "-"}<br />
          <strong>Professor:</strong> {data.professor?.name || data.course?.professors?.[0]?.name || "-"}<br />
          <strong>Dias da Semana:</strong> {(data.weeks && data.weeks.length > 0) ? data.weeks.map(w => w.name.charAt(0).toUpperCase() + w.name.slice(1)).join(", ") : "-"}<br />
          <strong>Início:</strong> {data.start_time}<br />
          <strong>Fim:</strong> {data.end_time}<br />
        </div>
        <div className="modal-buttons">
          <button className="btn-secondary" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default ConfigDetailsModal;
